import { useRouter } from '@uirouter/react';
import { useImmerAtom } from 'jotai-immer';
import { ROUTE_LIST } from '../../vendor_const';
import { editPageStateAtom } from '../vendor_edit_atoms';
import { PageStoreHook, VendorEditPageState, PageMode } from '../vendor_edit_types';
import { useCallback, useState } from 'react';

export const useVendorEditStore = (): PageStoreHook<VendorEditPageState> => {
    const router = useRouter();
    const [state, setState] = useImmerAtom(editPageStateAtom);
    const [waiting, setWait] = useState<boolean>(false);

    const setEditStatus = useCallback(
        (canEdit: boolean) => {
            setState(draft => ({ ...draft, canEdit }));
        },
        [setState],
    );

    const setPageMode = useCallback(
        (mode: PageMode, id: string, isTPA?: boolean): void => {
            setState(draft => ({
                ...draft,
                mode,
                title: mode === 'CREATE' ? 'Create Group' : 'Update Group',
                init: false,
                id,
                isTPA: isTPA ?? draft.isTPA,
            }));
        },
        [setState],
    );

    const cancelEdit = useCallback((): void => {
        router.stateService.go(ROUTE_LIST);
    }, [router.stateService]);

    return {
        state,
        setEditStatus,
        setPageMode,
        cancelEdit,
        waiting,
        setWait,
    };
};
